"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
const TOGGLE_STATE = {
    on: 'On',
    off: 'Off'
};
const Wrapper = styled_components_1.default.div `
    display: inline-flex;
    align-items: center;
    height: ${helpers_1.SIZE_XL};

    &:focus {
        outline: none;
    }
`;
const ToggleContainer = styled_components_1.default.div `
    display: inline-block;
    width: 40px;
    height: 20px;
`;
const Slider = styled_components_1.default.div `
    position: absolute;
    width: 30%;
    height: 60%;
    top: 20%;
    z-index: 2;
    border-radius: 50%;
    transition: left 0.2s ease-out 0s;
`;
const setBackgroundBorderColor = (backgroundColor, sliderColor, borderColor) => (0, styled_components_1.css) `
    &::after {
        background-color: ${backgroundColor};
        border-color: ${borderColor || backgroundColor};
    }

    ${Slider} {
        background-color: ${sliderColor};
    }
`;
const ToggleBody = styled_components_1.default.div `
    position: relative;
    width: 100%;
    height: 100%;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1;
        border-radius: 8px;
        border-style: solid;
        border-width: ${helpers_1.BASE_BORDER_WIDTH};
    }

    &:focus {
        outline: none;
    }

    & ${Slider} {
        left: ${({ checked }) => (checked ? '60%' : '10%')};
    }

    ${({ theme, checked, disabled }) => {
    if (disabled) {
        return checked
            ? setBackgroundBorderColor(theme.colorControlIconDisabled, theme.colorToggleButtonOff)
            : setBackgroundBorderColor(theme.colorToggleButtonOff, theme.colorControlIconDisabled, theme.colorControlBorderDisabled);
    }
    if (checked) {
        return (0, styled_components_1.css) `
                ${setBackgroundBorderColor(theme.colorToggleButtonOn, theme.colorToggleButtonOff)}

                &:focus {
                    ${setBackgroundBorderColor(theme.colorToggleButtonOn, theme.colorHighlightLight)}
                }
                &:hover {
                    ${setBackgroundBorderColor(theme.colorToggleButtonOn, theme.colorHighlightLight)}
                }
                &:active {
                    ${setBackgroundBorderColor(theme.colorToggleButtonOn, theme.colorHighlightDark)}
                }
            `;
    }
    return (0, styled_components_1.css) `
            ${setBackgroundBorderColor(theme.colorToggleButtonOff, theme.colorTextMain, theme.colorControlBorder)}

            &:focus {
                ${setBackgroundBorderColor(theme.colorToggleButtonOff, theme.colorTextMain, theme.colorControlBorderAccent)}
            }
            &:hover {
                ${setBackgroundBorderColor(theme.colorHighlightLight, theme.colorTextMain, theme.colorControlBorderAccent)}
            }
            &:active {
                ${setBackgroundBorderColor(theme.colorHighlightDark, theme.colorTextMain, theme.colorControlBorderAccent)}
            }
        `;
}};
`;
const ToggleSuffix = styled_components_1.default.span `
    margin-left: ${helpers_1.SPACING_S};
    font-family: ${helpers_1.BASE_FONT_FAMILY};
    font-size: ${helpers_1.FONT_SIZE_M};
    font-weight: ${helpers_1.BASE_FONT_NORMAL_WEIGHT};
    color: ${({ disabled, theme }) => (disabled ? theme.colorTextLight : theme.colorTextMain)};

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
`;
exports.Toggle = (0, helpers_1.createUIElement)('Toggle', (_a, ref) => {
    var { className, value = false, showSuffix = false, disabled = false, onChange, onBlur, onFocus, titles = {
        on: TOGGLE_STATE.on,
        off: TOGGLE_STATE.off
    }, tabIndex = 0, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "value", "showSuffix", "disabled", "onChange", "onBlur", "onFocus", "titles", "tabIndex", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const onClickHandle = () => {
        !disabled && (onChange === null || onChange === void 0 ? void 0 : onChange(!value));
    };
    const onKeyUpHandle = (e) => {
        if (!disabled && onChange && e.keyCode === helpers_1.KeyCode.Space) {
            onClickHandle();
        }
    };
    return (react_1.default.createElement(Wrapper, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'toggle', className: `vm-Toggle ${className}`, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style, tabIndex: -1 }),
        react_1.default.createElement(ToggleContainer, null,
            react_1.default.createElement(ToggleBody, { "data-selector-id": "toggle-body", toggle: "true", checked: value, disabled: disabled, onClick: onClickHandle, onKeyUp: onKeyUpHandle, onBlur: onBlur, onFocus: onFocus, tabIndex: disabled ? -1 : tabIndex },
                react_1.default.createElement(Slider, null))),
        showSuffix && (react_1.default.createElement(ToggleSuffix, { "data-selector-id": "toggle-suffix", disabled: disabled, onClick: onClickHandle }, value ? titles.on : titles.off))));
});
//# sourceMappingURL=Toggle.js.map